var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnsubscribe = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 12.75H6.5V13.25H3C2.30964 13.25 1.75 12.6904 1.75 12V4C1.75 3.30964 2.30964 2.75 3 2.75H13C13.6904 2.75 14.25 3.30964 14.25 4V7.5H13.75V6.04055V5.34684L13.0919 5.56621L7.99987 7.26355L2.90811 5.5663L2.25 5.34693V6.04064V12C2.25 12.4143 2.58583 12.75 3 12.75ZM7.84176 6.6838L7.99987 6.73651L8.15798 6.6838L13.4081 4.93375L13.75 4.81979V4.45941V4C13.75 3.58583 13.4143 3.25 13 3.25H3C2.58579 3.25 2.25 3.58579 2.25 4V4.4595V4.81988L2.59189 4.93384L7.84176 6.6838Z",
  fill: "currentcolor",
  stroke: "currentcolor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.25 11.5C10.25 11.3619 10.3619 11.25 10.5 11.25H13.5C13.6381 11.25 13.75 11.3619 13.75 11.5C13.75 11.6381 13.6381 11.75 13.5 11.75H10.5C10.3619 11.75 10.25 11.6381 10.25 11.5Z",
  fill: "currentcolor",
  stroke: "currentcolor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnsubscribe);
export default ForwardRef;